var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.6305C9 28.5654 10.0942 29.0723 10.8073 28.4677L30.555 11.7251C30.8373 11.4858 31 11.1345 31 10.7644C31 9.68408 29.7292 9.10506 28.914 9.81394L9.37737 26.8023C9.13764 27.0107 9 27.3128 9 27.6305ZM11.086 9.81394C10.2708 9.10506 9 9.68408 9 10.7644C9 11.1345 9.16274 11.4858 9.44502 11.7251L29.1927 28.4677C29.9058 29.0723 31 28.5654 31 27.6305C31 27.3128 30.8624 27.0107 30.6226 26.8023L11.086 9.81394Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.15a7777ed7fd773d209b632aba846f9e.svg";
export { ForwardRef as ReactComponent };